<template>
  <div class="overnight-params">
    <el-row>
      <el-col :span="12">
        遲歸時間:
        <el-time-picker
          type="time"
          size="small"
          value-format="HH:mm"
          format="HH:mm"
          :placeholder="$t('app.validation.time')"
          v-model="childrenData.laterDate"
        >
        </el-time-picker>
      </el-col>
      <el-col :span="12">
        外宿時間:
        <el-time-picker
          type="time"
          size="small"
          value-format="HH:mm"
          format="HH:mm"
          :placeholder="$t('app.validation.time')"
          v-model="childrenData.outerDate"
        >
        </el-time-picker>
      </el-col>
      <el-col :span="12">
        A門入:
        <el-input
          type="text"
          size="small"
          style="width: 250px"
          v-model="childrenData.doorAIn"
        >
        </el-input>
      </el-col>
      <el-col :span="12">
        A門出:
        <el-input
          type="text"
          size="small"
          style="width: 250px"
          v-model="childrenData.doorAOut"
        >
        </el-input>
      </el-col>
      <el-col :span="12">
        B門入:
        <el-input
          type="text"
          size="small"
          style="width: 250px"
          v-model="childrenData.doorBIn"
        >
        </el-input>
      </el-col>
      <el-col :span="12">
        B門出:
        <el-input
          type="text"
          size="small"
          style="width: 250px"
          v-model="childrenData.doorBOut"
        >
        </el-input>
      </el-col>
      <el-col :span="24">
        遲歸例外時間:
        <el-date-picker
          type="datetime"
          size="small"
          value-format="yyyy-MM-dd HH:mm"
          format="yyyy-MM-dd HH:mm"
          :placeholder="$t('app.validation.date')"
          style="width: 250px"
          v-model="dateA"
        >
        </el-date-picker>
        <el-button size="small" type="primary" @click="newDateA">{{
          $t("app.new")
        }}</el-button>
      </el-col>
      <div>
        <el-tag
          v-for="(item, index) in dateListA"
          :key="item"
          closable
          @close="delA(index)"
          style="margin-right: 20px"
          >{{ item }}</el-tag
        >
      </div>
      <el-col :span="24" style="margin-top: 20px">
        外宿例外時間:
        <el-date-picker
          type="datetime"
          size="small"
          value-format="yyyy-MM-dd HH:mm"
          format="yyyy-MM-dd HH:mm"
          :placeholder="$t('app.validation.date')"
          style="width: 250px"
          v-model="dateB"
        >
        </el-date-picker>
        <el-button size="small" type="primary" @click="newDateB">{{
          $t("app.new")
        }}</el-button>
      </el-col>
      <div>
        <el-tag
          v-for="(item, index) in dateListB"
          :key="item"
          closable
          @close="delB(index)"
          style="margin-right: 20px"
          >{{ item }}</el-tag
        >
      </div>
    </el-row>
    <span class="btn">
      <el-button size="small" type="warning" @click="reset">{{
        $t("app.reset")
      }}</el-button>
    </span>
  </div>
</template>
<script>
export default {
  props: {
    childrenData: {
      type: Object,
      default() {
        return {
          laterDate: "",
          outerDate: "",
          doorAIn: "",
          doorAOut: "",
          doorBIn: "",
          doorBOut: "",
          specialTimeA: "",
          specialTimeB: "",
        };
      },
    },
  },
  data() {
    return {
      dateA: "",
      dateB: "",
    };
  },
  computed: {
    dateListA() {
      return this.childrenData.specialTimeA
        .split(",")
        .filter((item) => item !== "");
    },
    dateListB() {
      return this.childrenData.specialTimeB
        .split(",")
        .filter((item) => item !== "");
    },
  },
  methods: {
    reset() {
      this.childrenData.laterDate = "";
      this.childrenData.outerDate = "";
      this.childrenData.doorAIn = "";
      this.childrenData.doorAOut = "";
      this.childrenData.doorBIn = "";
      this.childrenData.doorBOut = "";
      this.childrenData.specialTimeA = "";
      this.childrenData.specialTimeB = "";
    },
    delA(index) {
      let arr = JSON.parse(JSON.stringify(this.dateListA));
      arr.splice(index, 1);
      this.childrenData.specialTimeA = arr.join(",");
    },
    newDateA() {
      if (
        !this.dateA ||
        this.childrenData.specialTimeA.indexOf(this.dateA) >= 0
      ) {
        return;
      }
      this.childrenData.specialTimeA += ",";
      this.childrenData.specialTimeA += this.dateA;
    },
    delB(index) {
      let arr = JSON.parse(JSON.stringify(this.dateListB));
      arr.splice(index, 1);
      this.childrenData.specialTimeB = arr.join(",");
    },
    newDateB() {
      if (
        !this.dateB ||
        this.childrenData.specialTimeB.indexOf(this.dateB) >= 0
      ) {
        return;
      }
      this.childrenData.specialTimeB += ",";
      this.childrenData.specialTimeB += this.dateB;
    },
  },
};
</script>
<style lang="scss" scoped>
.overnight-params {
  min-height: 300px;
  padding-bottom: 50px;
  .el-row {
    .el-col {
      margin-bottom: 15px;
    }
  }
  .btn {
    position: absolute;
    bottom: 10px;
    right: 10px;
  }
}
</style>
